import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Freelance teaching is great, or why C/Java/etc. are horrible teaching tools",
  "description": "",
  "published": "2010-05-03T00:00:00.000Z",
  "redirect_from": ["/blog/freelance-teaching-is-great-or-why-cjavaetc-are-horrible-teaching-tools/swizec/1326"],
  "categories": "Education, food for thought, Language, Learning, life, Teacher, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "http://commons.wikipedia.org/wiki/Image:Jordanhill_college.jpg"
          }}><img parentName="a" {...{
              "src": "https://swizec.com/blog/wp-content/uploads/2010/05/300px-Jordanhill_college.jpg",
              "alt": "Main Building",
              "title": "Main Building"
            }}></img></a></p>
        <p parentName="li">{`Image via `}<a parentName="p" {...{
            "href": "http://commons.wikipedia.org/wiki/Image:Jordanhill_college.jpg"
          }}>{`Wikipedia`}</a></p>
      </li>
    </ul>
    <p>{`Seriously why aren't there more teachers in the world? What a bunch of charlatans.`}</p>
    <p>{`But I'm getting ahead of myself in this story.`}</p>
    <p>{`Last week I was doing a lot of freelancing as a teacher and instructor in the `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Magic_in_Harry_Potter",
        "title": "Magic in Harry Potter"
      }}>{`dark arts`}</a>{` of `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Computer_programming",
        "title": "Computer programming"
      }}>{`programming`}</a>{`. There was this kid who desperately wanted to get a passing grade on a test this Wednesday. And there was this guy with a hat who has never in his life done any teaching and has spent all his life adamantly convinced he's got no patience of such things. But he could do with some money in his pockets.`}</p>
    <p>{`So the story begins. We had a three hour session almost every day and an even better reward than the easiest lump of money I ever made, was the fact that kid suggested, and seriously meant it, that I should think about becoming a teacher when I "grow up". It was truly quite marvelous.`}</p>
    <p>{`And all I did was explain some basic things to him and make him think.`}</p>
    <p>{`Which brings us to the next question. Why was it that this poor bastard who has spent almost a year at the hands of professional teachers even needed someone to explain to him how a `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/For_loop",
        "title": "For loop"
      }}>{`for loop`}</a>{` works? How to distill an `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Algorithm",
        "title": "Algorithm"
      }}>{`algorithm`}</a>{` out of a problem description? How to ... stuff?`}</p>
    <p>{`I mean, seriously. What the hell!?`}</p>
    <p>{`They trouble these young dudes with details like variable types, function prototypes and the fact that this thing called Dev-C needs a System("PAUSE") at the end.`}</p>
    <p>{`All the while they don't even understand that a variable will just keep its value and that this (and loops) is the basic principle behind everything a computer does and that you can change the way a computer does something by tweaking values in variables.`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "http://commons.wikipedia.org/wiki/Image:Ataturkstatue.jpg"
          }}><img parentName="a" {...{
              "src": "https://swizec.com/blog/wp-content/uploads/2010/05/300px-Ataturkstatue.jpg",
              "alt": "Ataturk teaching the children of Turkey the La...",
              "title": "Ataturk teaching the children of Turkey the La..."
            }}></img></a></p>
        <p parentName="li">{`Image via `}<a parentName="p" {...{
            "href": "http://commons.wikipedia.org/wiki/Image:Ataturkstatue.jpg"
          }}>{`Wikipedia`}</a></p>
      </li>
    </ul>
    <p>{`Pretty pathetic if you ask me.`}</p>
    <p>{`When I was a little dude in that kid's shoes I hated flowcharts and I hated everything to do with real programming. All I wanted to do was pump out functioning code. But the thing is, far before that there was somebody to instill The Way a Programmer Thinks in my head. I already knew most of the basic stuff.`}</p>
    <p>{`But for those who don't understand thinking like a programmer. Who can't empathise with a computer. They need a different learning method and schools and universities (at least around here) are horrible when it comes to that. All they ever do at school is try teaching you languages before you even learn how to talk.`}</p>
    <p>{`Ever tried speaking a foreign language right out of the dictionary?`}</p>
    <p>{`That's how people try to teach you programming these days.`}</p>
    <p>{`It sucks and it's got to change.`}</p>
    <p>{`Personally I think pupils should be taught to do nothing but programming for at least a year when they start. Then, maybe, they could start getting into coding.`}</p>
    <p><a parentName="p" {...{
        "href": "http://reblog.zemanta.com/zemified/f7e63a2f-e5c1-42f3-acc6-9af9df602967/",
        "title": "Reblog this post [with Zemanta]"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/reblog_e.png?x-id=f7e63a2f-e5c1-42f3-acc6-9af9df602967",
          "alt": "Reblog this post [with Zemanta]"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      